import { fetchAuthSession } from 'aws-amplify/auth';
import axios, { AxiosRequestHeaders, ResponseType } from 'axios';
import configData from '../config/config.json';

export abstract class ApiBase {
  private static async getAuthHeaders(): Promise<{ [key: string]: string }> {
    const session = await fetchAuthSession();

    return {
      Authorization: `Bearer ${session.tokens?.accessToken.toString()}`,
      'Content-Type': 'application/json',
    };
  }

  private static async getHeaders(
    headers?: AxiosRequestHeaders
  ): Promise<AxiosRequestHeaders> {
    const authHeaders = await ApiBase.getAuthHeaders();
    return { ...headers, ...authHeaders } as AxiosRequestHeaders;
  }

  public static async get(
    path: string,
    params?: { [key: string]: any },
    headers?: AxiosRequestHeaders,
    responseType?: ResponseType,
    maxRedirects?: number
  ) {
    if (!responseType) responseType = 'json';
    if (!maxRedirects) maxRedirects = 0;

    headers = await ApiBase.getHeaders(headers);

    return axios.get(configData.BE_BASE_URL + path, {
      params,
      headers,
      responseType,
      maxRedirects,
    });
  }

  public static async post(
    path: string,
    body?: { [key: string]: any } | FormData,
    responseType?: ResponseType,
    maxRedirects?: number,
    headers?: AxiosRequestHeaders
  ) {
    if (!responseType) responseType = 'json';
    if (!maxRedirects) maxRedirects = 0;

    headers = await ApiBase.getHeaders(headers);

    return axios.post(configData.BE_BASE_URL + path, body, {
      headers,
      responseType,
      maxRedirects,
    });
  }

  public static async patch(
    path: string,
    body?: { [key: string]: any },
    headers?: AxiosRequestHeaders,
    responseType?: ResponseType,
    maxRedirects?: number
  ) {
    if (!responseType) responseType = 'json';
    if (!maxRedirects) maxRedirects = 0;

    headers = await ApiBase.getHeaders(headers);

    return axios.patch(configData.BE_BASE_URL + path, body, {
      headers,
      responseType,
      maxRedirects,
    });
  }

  public static async put(
    path: string,
    body?: { [key: string]: any },
    headers?: AxiosRequestHeaders,
    responseType?: ResponseType,
    maxRedirects?: number
  ) {
    if (!responseType) responseType = 'json';
    if (!maxRedirects) maxRedirects = 0;

    headers = await ApiBase.getHeaders(headers);

    return axios.put(configData.BE_BASE_URL + path, body, {
      headers,
      responseType,
      maxRedirects,
    });
  }

  public static async delete(
    path: string,
    params?: { [key: string]: any },
    headers?: AxiosRequestHeaders,
    responseType?: ResponseType,
    maxRedirects?: number
  ) {
    if (!responseType) responseType = 'json';
    if (!maxRedirects) maxRedirects = 0;

    headers = await ApiBase.getHeaders(headers);

    return axios.delete(configData.BE_BASE_URL + path, {
      params,
      headers,
      responseType,
      maxRedirects,
    });
  }

  public static async authGet(
    path: string,
    queryString?: { [key: string]: any },
    responseType?: ResponseType
  ) {
    return ApiBase.get(path, queryString, undefined, responseType);
  }
}
